//////////////////////////////////////////////////////////
//                                                      //   
//  PARA TODOS OS USUÁRIOS:                             //   
//                                                      //   
//  APARECE COMO A FOTO E OS BOTÕES DE VENDA            //   
//  DO CARD DE PRODUTOS NA PÁGINA HOME                  //   
//                                                      //   
//  FUNCIONALIDADE: MOSTRAR FOTO DOS PRODUTOS           //    
//    E TAMBÉM BOTÕES DE COMPRA                         //    
//                                                      //   
//////////////////////////////////////////////////////////    



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/components/preco_picture.js                        //
//                                                                      //
//////////////////////////////////////////////////////////////////////////



import CarrinhoButtonPqn from './carrinho_button_pqn';

import '../assets/css/local/picture.css';

function MockPicture(props) {

    // OS COMPONENTES DA PÁGINA SÃO (NA ORDEM QUE APARECEM):
        // 'CarrinhoButtonPqn' -> BOTÕES COM AS OPÇÕES DE COMPRA

    return (
        <div id={props.props.id} class="my-4 center">
            <div class="d-flex flex-wrap justify-content-center">
                <img class='picture w-100' src={props.props.props.img} alt="Avatar"></img>
            </div>
            <CarrinhoButtonPqn props={props} callback={props.callback} />
        </div>
    )
}

export default MockPicture;